import { accountAction } from "app/store/account/actions/accountAction";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accounts: [],
  allAccounts: [],
  accountsMapper: {},
};

const accountSlice = createSlice({
  name: "account",
  initialState: initialState,
  reducers: accountAction,
});

export const { loadAccounts, loadAllAccounts, loadAccountsMapper } =
  accountSlice.actions;

export default accountSlice.reducer;
